mutation updateCompanyBilling($input: UpdateCompanyBillingInput!) {
  company: updateCompanyBilling(input: $input) {
    id
    billing {
      vatId
      taxNumber
      vatIdRequestDate
      iban
      bic
      paymentMethod
      sepaValidAsOf
      hasSeparateBillingAddress
      contact {
        firstname
        lastname
        email
        phone
        companyName
        companyNameAddition
      }
      address {
        street
        zip
        city
      }
    }
  }
}
